import * as actionTypes from "../action-types";
import { AI_DEFAULT_LABELS } from "../../config/aiGenerateOptions";

const initSetting = {
  modalWriteReview: {
    primary_color: {
      color: "#3D4153",
    },
    color_customize: {
      form_write_review_star_color: "#FFB400",

      modal_submitted_review_success_popup_background: "#FFFFFF",
      modal_submitted_review_success_popup_icon: "#28A52D",
      modal_submitted_review_success_popup_headline: "#3D4153",
      modal_submitted_review_success_popup_content: "#616161",
      modal_submitted_review_success_product_name: "#3D4153",
      modal_submitted_review_success_product_price: "#74788D",
      modal_submitted_review_success_customer_name: "#303030",
      modal_submitted_review_success_customer_email: "#616161",
      modal_submitted_review_success_review_card_background: "#FFFFFF",
      modal_submitted_review_success_review_card_title: "#3D4153",
      modal_submitted_review_success_review_card_content: "#3D4153",
      modal_submitted_review_success_review_card_border: "#DEDFE6",
      modal_submitted_review_success_star_active: "#FFB400",
      modal_submitted_review_success_star_disable: "#D4D4D4",
      modal_submitted_review_success_button_background: "#303030",
      modal_submitted_review_success_button_title: "#FFFFFF",

      modal_submitted_review_pending_popup_background: "#FFFFFF",
      modal_submitted_review_pending_popup_icon: "#FFB400",
      modal_submitted_review_pending_popup_headline: "#3D4153",
      modal_submitted_review_pending_popup_content: "#616161",
      modal_submitted_review_pending_product_name: "#3D4153",
      modal_submitted_review_pending_product_price: "#74788D",
      modal_submitted_review_pending_customer_name: "#303030",
      modal_submitted_review_pending_customer_email: "#616161",
      modal_submitted_review_pending_review_card_background: "#FFFFFF",
      modal_submitted_review_pending_review_card_title: "#3D4153",
      modal_submitted_review_pending_review_card_content: "#3D4153",
      modal_submitted_review_pending_review_card_border: "#DEDFE6",
      modal_submitted_review_pending_star_active: "#FFB400",
      modal_submitted_review_pending_star_disable: "#D4D4D4",
      modal_submitted_review_pending_button_background: "#303030",
      modal_submitted_review_pending_button_title: "#FFFFFF",
    },
    section_show: {
      // Keys kept from the widget settings API (filterResponse copies only keys
      // listed here); defaults from trustshop-fe defaultReviewDisplaySetting.
      // Reviewer avatar / country flag on the review card after submit.
      customer_profile_picture: false,
      customer_country_flag: false,
      form_write_review: {
        show_product_info: false,
        show_product_image: true,
        show_add_photo_btn: true,
        show_add_video_btn: true,
        required_review_title: true,
        star_size: 32,
        hide_review_title: false,
        review_ai_generation: false,
        show_option_name_selected: true,
        show_example: true,
        show_help_tooltip: true,
        show_option_name_display_format: {
          option_1: true,
          option_2: true,
          option_3: true,
          option_4: true,
        },
      },
      // Store review form: own key names, mapped by resolveFormSetting
      form_write_store_review: {
        show_store_info: true,
        show_add_photo_btn: true,
        show_add_video_btn: false,
        show_review_title: false,
        star_size: 32,
      },
      submitted_review_popup: {
        pending: {
          review_card: "default", // default/without_media/disable
          headline_title_size: 24,
          content_label_size: 14,
          button_label_size: 14,
        },
        success: {
          review_card: "default", // default/without_media/disable
          headline_title_size: 24,
          content_label_size: 14,
          button_label_size: 14,
        },
      },
    },
    label_content: {
      modal_write_title: "Ratings & Reviews",
      modal_write_title_had_review: "Thank you for leaving reviews",
      modal_write_text_reviews: "Reviews",
      modal_review_text_click_to_rate: "Click to rate",
      modal_review_add_photo_or_video: "Add photo or video",
      name_display_format: "Name display format",
      option_name_display_format_1: "John Smith",
      option_name_display_format_2: "John S.",
      option_name_display_format_3: "J.S.",
      option_name_display_format_4: "Anonymous",
      modal_review_label_customer_name: "Customer Name",
      modal_review_placeholder_customer_name: "Type your name here",
      name_preview_help_text: "Your name will appear as",
      name_display_tooltip:
        "If you choose anonymous, your name will be hidden from everyone",
      name_override_notice:
        "Your name will be displayed as {{name_display}} on our store",
      modal_review_label_customer_email: "Customer Email",
      modal_review_placeholder_customer_email:
        "Your email is private and is used to send you discount vouchers",
      modal_review_label_review_title: "Review Title",
      modal_review_placeholder_review_title: "Example: Easy to use",
      modal_review_label_review_content: "Product Review",
      modal_review_label_review_media: "Upload media",
      modal_review_placeholder_upload_photo:
        "Upload up to 5 photos drag & drop or {{click_here}} to upload files",
      modal_review_placeholder_upload_video:
        "Upload up to 2 videos drag & drop or {{click_here}} to upload files",
      modal_review_placeholder_upload_media:
        "Upload up to 5 photos & 2 videos drag & drop or {{click_here}} to upload files",
      modal_review_placeholder_review_content:
        "Example: Since i bought this a month ago, it has been used a lot. What i like best this product is...",
      modal_review_label_characters_remaining: "characters remaining",
      modal_review_btn_add_photo: "Photo",
      modal_review_btn_add_video: "Video",
      modal_review_btn_back: "Back",
      modal_review_btn_submit_review: "Submit Review",
      modal_review_btn_submit_review_has_review: "Go Shopping",
      modal_pending_review_title: "Review in review",
      modal_pending_review_subtitle:
        "Thanks for your review! We'll review it to ensure it meets our guidelines. Please give us some time to assess it thoroughly.",
      modal_pending_review_button: "Continue Shopping",
      modal_success_review_title: "Review submitted successfully!",
      modal_success_review_subtitle:
        "Thank you for spending time sharing your experience and leaving feedback, it will be very beneficial for other customers.",
      modal_success_review_button: "Continue Shopping",

      required_input: "*Please fill out this field",
      required_email: "*Please enter a valid email address!",
      media_rule_size: "*Media size must be smaller than 10MB",
      media_rule_type: "*Media type must be .bmp, .jpeg, .png, .mp4 or .mov",
      media_upload_fail: "*Unable to upload the image. Please try again later",
      media_upload_duplicate: "*You have already uploaded this image",
      modal_image_review_for: "Review for",
      modal_image_from_this_review: "Image from this review",
      modal_review_btn_add_photo_subtitle: "Max file size: 10MB",
      modal_review_btn_add_video_subtitle: "Max file size: 50MB",
      photo_rule_size: "*Photo size must be smaller than 10MB",
      video_rule_size: "*Video size must be smaller than 50MB",
      photo_rule_max: "*You can only upload 5 photos per review",
      video_rule_max: "*You can only upload 2 video per review",
      ...AI_DEFAULT_LABELS,
    },
  },
  discountSetting: {
    status: false,
    display_on: "after_review_submitted",
    icon: null,
    message: {
      title_label: "Thanks for Your Review. Your Discount Code Is Now Ready!",
      description_label:
        "Thank you for submitting your review. Your discount code is ready and sent to your email. ",
    },
    button_title: "Use discount",
    color_customize: {
      discount_code_color: "#2C7695",
      discount_message_background_color: "#EAF4FF",
      title_label_color: "#28A52D",
      description_label_color: "#303030",
    },
    setting: {
      show_submitted_review: true,
      star_rating: [],
      target_product: "all", // all/include/exclude
      products: [],
    },
  },
};

const settingFormWriteReview = (state, action) => {
  return {
    ...state,
    modalWriteReview: {
      ...state.modalWriteReview,
      ...action.payload,
      fetch_status: true,
    },
  };
};

const settingDiscount = (state, action) => {
  return {
    ...state,
    discountSetting: {
      ...state.discountSetting,
      ...action.payload,
      fetch_status: true,
    },
  };
};

const Setting = (state = initSetting, action) => {
  switch (action.type) {
    case actionTypes.SETTING_WIDGET:
      return settingFormWriteReview(state, action);
    case actionTypes.SETTING_DISCOUNT:
      return settingDiscount(state, action);
    default:
      return state;
  }
};

export default Setting;
